<nz-result
  class="like-pre"
  [nzIcon]="icon"
  [nzTitle]="title"
  [nzSubTitle]="subTitle | emSplitString: '§§§' : 0"
  [nzStatus]="status"
></nz-result>
<nz-collapse *ngIf="subTitle | emHasFullError">
  <nz-collapse-panel class="like-pre" [nzHeader]="'Full error'" [nzActive]="false">
    <span>{{ subTitle | emSplitString: '§§§' : 1 }}</span>
  </nz-collapse-panel>
</nz-collapse>
